/* eslint-disable */
import { useAuth } from "@saleor/auth/AuthProvider";
import { useShopApisList, useGetLng } from "@saleor/components/Shop/query";
import { getShopAPI, setShopAPI } from "@saleor/config";
import { ShopApiFragment } from "@saleor/fragments/types/ShopApiFragment";
import useLocalStorage from "@saleor/hooks/useLocalStorage";
import useNavigator from "@saleor/hooks/useNavigator";
import React from "react";

interface UseAppShopApi {
  shopApi: ShopApiFragment;
  availableShopApis: ShopApiFragment[];
  isPickerActive: boolean;
  refreshShopApis: () => void;
  setShopApi: (id: string) => void;

  [key: string]: any;
}

export interface AppShopApiContextData extends UseAppShopApi {
  setPickerActive: (isActive: boolean) => void;
}

const AppShopApiContext = React.createContext<AppShopApiContextData>({
  availableLngs: [],
  availableShopApis: [],
  isPickerActive: false,
  refreshShopApis: () => undefined,
  setPickerActive: () => undefined,
  setShopApi: () => undefined,
  shopApi: undefined
});

export const AppShopApiProvider: React.FC = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [selectedShopApi, setSelectedShopApi] = useLocalStorage(
    "shop_api_id",
    ""
  );
  const [, setSelectedShopName] = useLocalStorage("shop_api_Name", undefined);

  const [selectedLng, setSelectedlng] = useLocalStorage("lng_code", "EN");
  const { data: shopApiData, refetch } = useShopApisList({
    skip: !isAuthenticated
  });
  const { data: lngData } = useGetLng({});

  const [isPickerActive, setPickerActive] = React.useState(false);

  const availableShopApis = shopApiData?.shopApis || [];
  const current_api_uri = getShopAPI().api_uri;

  const availableLngs = lngData?.shop?.languages.map(i => ({
    id: i.code,
    name: i.language
  }));
  const current_lngCode = JSON.parse(localStorage.getItem("lng_code"));
  const default_lng = availableLngs?.find(lng => lng.id === current_lngCode);
  React.useEffect(() => {
    if (shopApiData?.shopApis?.length > 0) {
      const default_api = availableShopApis.find(
        shopApi => shopApi.uri === current_api_uri
      );
      if (!!default_api) {
        // 默认站点
        setSelectedShopApi(default_api.id);
        setSelectedShopName(default_api.name);
        // 默认语言站
        if (!!default_lng) {
          setSelectedlng(default_lng.id);
          localStorage.setItem("lng_name", default_lng?.name);
        } else {
          setSelectedlng(availableLngs[0].id);
          localStorage.setItem("lng_name", availableLngs[0].name);
        }

        // 装修平台
        // cookie.save("shop_platform", default_api.name, { path: "/" });
      } else {
        // 默认站点
        setSelectedShopApi(shopApiData.shopApis[0].id);
        setSelectedShopName(shopApiData.shopApis[0].name);
        setShopAPI(shopApiData.shopApis[0].uri);
        // 默认语言站
        setSelectedlng(availableLngs[0].id);
        localStorage.setItem("lng_name", availableLngs[0].name);
        // 装修平台
        // cookie.save("shop_platform", shopApiData.shopApis[0].name, {
        //   path: "/"
        // });

        location.reload();
      }
    }
  }, [shopApiData]);

  const shopApi =
    shopApiData &&
    (availableShopApis.find(shopApi => shopApi.id === selectedShopApi) || null);
  const navigate = useNavigator();

  React.useEffect(() => {
    const lng_name = localStorage.getItem("lng_name");
    if (
      (!!shopApi && shopApi.uri !== current_api_uri) ||
      (!!default_lng && lng_name !== default_lng?.name)
    ) {
      // 切换店铺接口
      setShopAPI(shopApi.uri);
      const locationUrl = window?.location?.href.replace(/\/[A-Z]+.*$/g, "/");
      console.log(locationUrl);
      if (locationUrl) {
        window.location.href = locationUrl;
      } else {
        navigate("/");
      }
      // navigate('/');

      // 装修平台
      // cookie.save("shop_platform", shopApi.name, { path: "/" });
      // location.reload();
      // navigate("/", true);
      // location.reload();
    }
  }, [shopApi, selectedLng]);

  return (
    <AppShopApiContext.Provider
      value={{
        availableShopApis,
        isPickerActive,
        refreshShopApis: refetch,
        setPickerActive,
        setShopApi: setSelectedShopApi,
        shopApi,
        availableLngs,
        setLng: setSelectedlng,
        lng: selectedLng
      }}
    >
      {children}
    </AppShopApiContext.Provider>
  );
};

AppShopApiProvider.displayName = "AppShopApiProvider";

function useAppShopApi(enablePicker = true): UseAppShopApi {
  const { setPickerActive, ...data } = React.useContext(AppShopApiContext);
  React.useEffect(() => {
    if (enablePicker) {
      setPickerActive(true);
    }

    return () => setPickerActive(false);
  }, [enablePicker]);

  return data;
}

export default useAppShopApi;
